export const TCG_CATEGORIES = [
  'All',
  'Booster Pack',
  'Booster Display',
  'Decks',
  'Bundles',
  'Starter Sets',
  'Draft Night',
  'Scene Boxes',
  'Prerelease',
  'Secret Lair',
  'Tins',
  'Special Sets',
]

export const ACCESSORY_CATEGORIES = [
  'All',
  'Sleeves',
  'Inner Sleeves',
  'Outer Sleeves',
  'Deck Boxes',
  'Binders',
  'Playmats',
  'Storage',
  'Dice',
  'Board Game Sleeves',
  'Graded Card Cases',
  'Pocket Pages',
  'Top Loaders',
  'Paints & Finishes',
  'Brushes',
  'Tools',
  'Basing & Terrain',
  'Metal Coins',
  'Primers & Varnish',
]
